import { Injectable, EventEmitter } from '@angular/core';
import { Http } from '@angular/http';

import { BaseService } from './base.service';

import { HttpRequest, HttpEventType, HttpResponse, HttpClient, HttpHeaders, HttpHeaderResponse,
  HttpErrorResponse } from '@angular/common/http';
import { UploadingFile } from '../home/uploader/uploader.component';
import { Bucket } from '../models/bucket.enum';
import { Upload } from '../models/upload.model';

@Injectable()
export class UploaderService extends BaseService {
  constructor(protected http: Http, private httpClient: HttpClient) {
    super(http);
  }

  // developed here as opposed to base service, for reasons...
  // it didn't come out awesome but it works
  public upload(formData: FormData, bucket: Bucket): EventEmitter<any> {

    const eventEmitter = new EventEmitter<any>();

    const req = new HttpRequest('POST', super.getBaseUrl() + bucket, formData, {
      headers: new HttpHeaders().set('Authorization', sessionStorage.getItem('Authorization')),
      reportProgress: true
    });

    this.httpClient.request(req).subscribe(event => {
      if (event.type === HttpEventType.UploadProgress) {
        const percentDone = Math.round(100 * event.loaded / event.total);
        // consumer expects a number to update percentage complete
        eventEmitter.emit(percentDone);
      }
      else if (event instanceof HttpResponse) {
        if (event.status === 200) {
          // consumer expects empty emit on done/success
          eventEmitter.emit();
        }
        else {
          // consumer expects a string with status on error
          eventEmitter.emit(event.statusText);
        }
        eventEmitter.complete();
      }
      else if (event instanceof HttpHeaderResponse) {
        if (!event.ok) {
          eventEmitter.emit(event.statusText);
          eventEmitter.complete();
        }
      }
      else if (event instanceof HttpErrorResponse) {
        if (!event.ok) {
          eventEmitter.emit(event.statusText);
          eventEmitter.complete();
        }
      }
    });

    return eventEmitter;
  }

  public async getTemporaryUploadInfo(guid: string): Promise<any> {
    return this.post('temporaryUpload', { guid: guid });
  }

  public temporaryUpload(file, guid: string, form: { fields: any, url: any }): EventEmitter<any> {

    const eventEmitter = new EventEmitter<any>();

    const formData = new FormData();
    for (const key in form.fields) {
      if (form.fields[key]) {
        formData.append(key, form.fields[key]);
      }
    }
    formData.append('file', file, guid);

    try {
      const req = new HttpRequest('POST', form.url.href, formData, {
        reportProgress: true
      });

      this.httpClient.request(req).subscribe(event => {
        if (event.type === HttpEventType.UploadProgress) {
          const percentDone = Math.round(100 * event.loaded / event.total);
          // consumer expects a number to update percentage complete
          eventEmitter.emit(percentDone);
        }
        else if (event instanceof HttpResponse) {
          if (event.status === 204) {
            // consumer expects empty emit on done/success
            eventEmitter.emit();
          }
          else {
            // consumer expects a string with status on error
            eventEmitter.emit(event.statusText);
          }
          eventEmitter.complete();
        }
        else if (event instanceof HttpHeaderResponse) {
          if (!event.ok) {
            eventEmitter.emit(event.statusText);
            eventEmitter.complete();
          }
        }
        else if (event instanceof HttpErrorResponse) {
          if (!event.ok) {
            eventEmitter.emit(event.statusText);
            eventEmitter.complete();
          }
        }
      });
    }
    catch (err) {
      console.log('temporaryUpload err', err);
    }

    return eventEmitter;
  }

  public submit(file: UploadingFile): Promise<Upload> {
    return this.post('submitUpload', file);
  }

  public processGradingSpreadsheet(file: UploadingFile) {
    return this.post('processGradingSpreadsheet', file);
  }

  public deleteTemporaryUpload(file: UploadingFile) {
    return this.delete('temporaryUpload/' + file._id);
  }

  public linkPedigree(familyId: string, pedigreePictureGuid: string) {
    return this.post('linkPedigree', {familyId: familyId, pedigreePictureGuid: pedigreePictureGuid});
  }

  public getUploadRecord(uploadId: number): Promise<Upload> {
    return this.get('upload/' + uploadId);
  }

  public saveResubmission(oldUploadId: number, newUploadId: number): Promise<Upload> {
    return this.post('upload/resubmit', { oldUploadId: oldUploadId, newUploadId: newUploadId });
  }

  public checkIfReplaceExisting(uploadDetails: Object): Promise<Upload> {
    return this.post('upload/findFromDetails', uploadDetails);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/uploader.service.ts